import { HttpErrorResponse, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { SubUrlsEnum } from '../enums/sub-urls.enum';
import { ILoginIn } from '../interfaces/auth.interface';

export const mockAuthRes: any = (request: HttpRequest<any>): Observable<HttpResponse<any> | HttpErrorResponse> => {
    if (request.method === 'POST' && request.url.endsWith(SubUrlsEnum.LOGIN)) {
        const login: ILoginIn = {
            access_token: 'access token',
            refresh_token: 'refresh token',
        };
        const response: any = {
            status: 200,
            body: { login },
        };
        return of(new HttpResponse(response));
    }
    if (request.method === 'POST' && request.url.endsWith(SubUrlsEnum.REFRESH_TOKEN)) {
        const response: any = {
            status: 200,
            body: {
                access_token: 'test_access_token',
                refresh_token: 'test_refresh_token',
            },
        };
        return of(new HttpResponse(response));
    }

    if (request.method === 'POST' && request.url.endsWith(SubUrlsEnum.RESET_PWD)) {
        const response: any = {
            status: 204,
        };
        return of(new HttpResponse(response));
    }

    if (request.method === 'DELETE' && request.url.endsWith(SubUrlsEnum.LOGOUT)) {
        const response: any = {
            status: 204,
        };
        return of(new HttpResponse(response));
    }

    return of(new HttpResponse());
};
